'use client';

import { Root } from '@radix-ui/react-toggle-group';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { ToggleGroupItem } from './toggle-group-item';
import './toggle-group.scss';

type Props = ComponentPropsWithoutRef<typeof Root>;
const ToggleGroupRoot = ({ className, ...props }: Props) => {
    return <Root className={cn('toggle-group', className)} {...props} />;
};

export const ToggleGroup = Object.assign(ToggleGroupRoot, {
    Item: ToggleGroupItem,
});
